import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "event"]

  filter(event) {
    const filter = event.currentTarget.value

    this.eventTargets.forEach(eventEl => {
      if (filter === "all" || eventEl.dataset.spectacle === filter) {
        eventEl.classList.remove("hidden")
      } else {
        eventEl.classList.add("hidden")
      }
    })
  }
}
